import React from 'react';
import { Link } from 'react-router-dom';
import { MapPinIcon, WrenchIcon, CalendarIcon, ShieldCheckIcon } from 'lucide-react';
export function WhyChooseUsSection() {
  return <section className="w-full py-20 px-4 sm:px-6 lg:px-8" style={{
    background: '#F5F5F5'
  }} data-id="element-577">
      <div className="max-w-7xl mx-auto" data-id="element-578">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-579">
          <h2 className="font-black text-black text-3xl sm:text-4xl mb-4" data-id="element-580">
            Why Choose Ameritech Tires?
          </h2>
          <p className="text-base max-w-2xl mx-auto" style={{
          color: '#616365'
        }} data-id="element-581">
            Ameritech Tires stands out for its fast, reliable, and professional
            tire services at all 3 DMV locations.
          </p>
        </div>

        {/* Feature Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-582">
          {/* Feature 1 */}
          <div className="bg-white p-8 shadow-sm" data-id="element-583">
            <div className="w-14 h-14 rounded-full flex items-center justify-center mb-5" style={{
            background: '#CC0000'
          }} data-id="element-584">
              <MapPinIcon size={24} className="text-white" data-id="element-585" />
            </div>
            <h3 className="font-black text-black text-lg mb-3" data-id="element-586">
              Walk In Anytime
            </h3>
            <p className="text-sm leading-relaxed mb-4" style={{
            color: '#616365'
          }} data-id="element-587">
              No appointment needed at any of our 3 DMV locations. Drive in and
              we will take care of you — open 24 hours, every day.
            </p>
            <Link to="/locations" className="font-semibold text-sm transition-colors duration-200" style={{
            color: '#CC0000'
          }} onMouseEnter={e => e.currentTarget.style.color = '#AA0000'} onMouseLeave={e => e.currentTarget.style.color = '#CC0000'} data-id="element-588">
              Read more →
            </Link>
          </div>

          {/* Feature 2 */}
          <div className="bg-white p-8 shadow-sm" data-id="element-589">
            <div className="w-14 h-14 rounded-full flex items-center justify-center mb-5" style={{
            background: '#1A3BCC'
          }} data-id="element-590">
              <WrenchIcon size={24} className="text-white" data-id="element-591" />
            </div>
            <h3 className="font-black text-black text-lg mb-3" data-id="element-592">
              Expert Technicians
            </h3>
            <p className="text-sm leading-relaxed mb-4" style={{
            color: '#616365'
          }} data-id="element-593">
              Fully trained and certified technicians handle every job with
              precision. Quality service at affordable prices, guaranteed.
            </p>
            <Link to="/services" className="font-semibold text-sm transition-colors duration-200" style={{
            color: '#1A3BCC'
          }} onMouseEnter={e => e.currentTarget.style.color = '#1530A8'} onMouseLeave={e => e.currentTarget.style.color = '#1A3BCC'} data-id="element-594">
              Read more →
            </Link>
          </div>

          {/* Feature 3 */}
          <div className="bg-white p-8 shadow-sm" data-id="element-595">
            <div className="w-14 h-14 rounded-full flex items-center justify-center mb-5" style={{
            background: '#CC0000'
          }} data-id="element-596">
              <CalendarIcon size={24} className="text-white" data-id="element-597" />
            </div>
            <h3 className="font-black text-black text-lg mb-3" data-id="element-598">
              Fast Turnaround
            </h3>
            <p className="text-sm leading-relaxed mb-4" style={{
            color: '#616365'
          }} data-id="element-599">
              Most tire services completed in under 45 minutes. We respect your
              time and get you back on the road quickly.
            </p>
            <Link to="/contact" className="font-semibold text-sm transition-colors duration-200" style={{
            color: '#CC0000'
          }} onMouseEnter={e => e.currentTarget.style.color = '#AA0000'} onMouseLeave={e => e.currentTarget.style.color = '#CC0000'} data-id="element-600">
              Read more →
            </Link>
          </div>

          {/* Feature 4 */}
          <div className="bg-white p-8 shadow-sm" data-id="element-601">
            <div className="w-14 h-14 rounded-full flex items-center justify-center mb-5" style={{
            background: '#1A3BCC'
          }} data-id="element-602">
              <ShieldCheckIcon size={24} className="text-white" data-id="element-603" />
            </div>
            <h3 className="font-black text-black text-lg mb-3" data-id="element-604">
              Peace of Mind
            </h3>
            <p className="text-sm leading-relaxed mb-4" style={{
            color: '#616365'
          }} data-id="element-605">
              Reliable service, trained technicians, and top-grade tire brands.
              Drive away confident every single time.
            </p>
            <Link to="/services" className="font-semibold text-sm transition-colors duration-200" style={{
            color: '#1A3BCC'
          }} onMouseEnter={e => e.currentTarget.style.color = '#1530A8'} onMouseLeave={e => e.currentTarget.style.color = '#1A3BCC'} data-id="element-606">
              Read more →
            </Link>
          </div>
        </div>
      </div>
    </section>;
}